import { render, staticRenderFns } from "./TitleDetailHeroV1.vue?vue&type=template&id=d6bb71fc&scoped=true"
import script from "./TitleDetailHeroV1.vue?vue&type=script&lang=ts&setup=true"
export * from "./TitleDetailHeroV1.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TitleDetailHeroV1.vue?vue&type=style&index=0&id=d6bb71fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6bb71fc",
  null
  
)

export default component.exports